import { CanvasEventTool } from "./canvasEventTool";

export class PositionClickTool extends CanvasEventTool {
    getName(): string {
        return "SmartDrawings.PositionClickTool";
    }
}